export default "__VITE_ASSET__Dd1CJ2Kg__"